import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-331cc47b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fr-panel" };
const _hoisted_2 = { class: "fr-panel__title" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "ic" }, "🔒", -1));
const _hoisted_4 = { class: "fr-center fr-hint" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_6 = { class: "fr-otp" };
const _hoisted_7 = ["value", "maxlength", "autocomplete", "onInput", "onKeydown"];
const _hoisted_8 = { class: "fr-otp-meta" };
const _hoisted_9 = {
    key: 0,
    class: "fr-otp-meta__time"
};
const _hoisted_10 = {
    key: 1,
    class: "fr-otp-meta__expired"
};
const _hoisted_11 = ["disabled"];
const _hoisted_12 = { class: "fr-btnrow" };
const _hoisted_13 = ["disabled"];
import { t } from '@vue/services/interval-lang';
import { bookingState } from '@vue/services/interval-store';
import { onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OtpVerify',
    props: {
        sending: { type: Boolean },
        resendIn: {},
        expiresIn: {}
    },
    emits: ['back', 'verify', 'resend'],
    setup(__props, { emit: __emit }) {
        /**
         * OTP 驗證（原型步驟 4）。
         *
         * 六格分開輸入。第一格 maxlength 刻意設 6 而不是 1：
         * iOS 的簡訊驗證碼自動填入會把整串六位數塞進聚焦的那一格，
         * maxlength=1 會讓它只填得進第一碼，客人得自己補後面五碼。
         * 收到多位數就逐格分配，貼上整串也是同一條路徑。
         */
        const props = __props;
        const emits = __emit;
        const digits = ref(['', '', '', '', '', '']);
        const inputs = ref([]);
        onMounted(() => {
            inputs.value[0]?.focus();
        });
        function setInputRef(el, i) {
            if (el) {
                inputs.value[i] = el;
            }
        }
        function onInput(e, i) {
            const el = e.target;
            const value = el.value.replace(/\D/g, '');
            // iOS 自動填入／貼上整串驗證碼 → 逐格分配
            if (value.length > 1) {
                for (let k = 0; k < digits.value.length; k++) {
                    digits.value[k] = value[k] || '';
                }
                const focusAt = Math.min(value.length, digits.value.length) - 1;
                inputs.value[focusAt]?.focus();
                return;
            }
            digits.value[i] = value;
            if (value && inputs.value[i + 1]) {
                inputs.value[i + 1].focus();
            }
        }
        /** 退格在空格上時往前跳一格，不然客人得自己點回去。 */
        function onKeydown(e, i) {
            if (e.key === 'Backspace' && !digits.value[i] && i > 0) {
                inputs.value[i - 1]?.focus();
            }
        }
        function submit() {
            emits('verify', digits.value.join('').trim());
        }
        /** 秒數轉 m:ss；剩 300 秒時顯示「5:00」比「300 秒」好讀。 */
        function formatSec(sec) {
            const s = Math.max(0, Math.floor(sec));
            return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
        }
        /**
         * 重送。倒數未歸零就不送，免得白打一趟後端只換回
         * OTP_RESEND_TOO_FREQUENT——按鈕本身也是 disabled，這是第二道。
         */
        function resend() {
            if (props.resendIn > 0 || props.sending) {
                return;
            }
            digits.value = ['', '', '', '', '', ''];
            inputs.value[0]?.focus();
            emits('resend');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("h2", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('bk.s4title')), 1)
                ]),
                _createElementVNode("p", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_unref(t)('bk.otpHint')) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(_unref(bookingState).verifyDest || _unref(t)('bk.notFilled')), 1),
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_unref(t)('bk.otpDemo')), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(digits.value, (d, i) => {
                        return (_openBlock(), _createElementBlock("input", {
                            key: i,
                            ref_for: true,
                            ref: (el) => setInputRef(el, i),
                            value: d,
                            class: "fr-input",
                            maxlength: i === 0 ? 6 : 1,
                            inputmode: "numeric",
                            autocomplete: i === 0 ? 'one-time-code' : 'off',
                            onInput: ($event) => (onInput($event, i)),
                            onKeydown: ($event) => (onKeydown($event, i))
                        }, null, 40, _hoisted_7));
                    }), 128))
                ]),
                _createElementVNode("div", _hoisted_8, [
                    (props.expiresIn > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)('bk.otpExpiresIn', { n: formatSec(props.expiresIn) })), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('bk.otpExpired')), 1)),
                    _createElementVNode("button", {
                        type: "button",
                        class: "fr-otp-resend",
                        disabled: props.resendIn > 0 || props.sending,
                        onClick: resend
                    }, _toDisplayString(props.resendIn > 0
                        ? _unref(t)('bk.otpResendIn', { n: props.resendIn })
                        : _unref(t)('bk.otpResend')), 9, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "fr-btn fr-btn--ghost",
                        onClick: _cache[0] || (_cache[0] = ($event) => (emits('back')))
                    }, _toDisplayString(_unref(t)('common.prev')), 1),
                    _createElementVNode("button", {
                        type: "button",
                        class: "fr-btn",
                        disabled: props.sending,
                        onClick: submit
                    }, _toDisplayString(props.sending ? _unref(t)('bk.sending') : _unref(t)('bk.confirm')), 9, _hoisted_13)
                ])
            ]));
        };
    }
});
